import $ from 'jquery'
import Quill from 'quill.js'
import moment from 'moment'
// import showModal from '../main.js'

$(document).on('click', '.save-btn', () => {
  saveArticle(true)
})

const icons = Quill.import('ui/icons')
icons.header[3] = `
<svg viewBox="0 0 18 18">
  <path class="ql-fill" d="M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/>
</svg>
`
// $('.dropdown-item').on('click', (e) => {
//   e.preventDefault()
// })

const BubbleTheme = Quill.import('themes/bubble')
class ExtendBubbleTheme extends BubbleTheme {
  constructor(quill, options) {
    super(quill, options)
    quill.on('selection-change', (range) => {
      if (range) {
        quill.theme.tooltip.show()
        quill.theme.tooltip.position(quill.getBounds(range))
      }
    })
    quill.on('text-change', (delta, oldDelta, source) => {
      const last = delta.ops[delta.ops.length - 1]
      if (Object.prototype.hasOwnProperty.call(last, 'insert') && last.insert === '\n') {
        quill.theme.tooltip.show()
        quill.theme.tooltip.position(quill.getBounds(source))
      }
    })
  }
}
Quill.register('themes/bubble', ExtendBubbleTheme)

const BlockEmbed = Quill.import('blots/block/embed')
class VideoBlot extends BlockEmbed {
  static create(url) {
    const node = super.create(url)
    const iframe = document.createElement('iframe')
    // Set styles for wrapper
    node.setAttribute('class', 'embed-responsive embed-responsive-16by9')
    // Set styles for iframe
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', true)
    iframe.setAttribute('src', url)
    // Append iframe as child to wrapper
    node.appendChild(iframe)
    return node
  }

  static value(domNode) {
    let src = null
    if (domNode.childElementCount > 0 && domNode.firstChild.nodeType === 1 && domNode.firstChild.hasAttribute('src')) {
      src = domNode.firstChild.getAttribute('src')
    }
    return src
  }
}
VideoBlot.blotName = 'video'
VideoBlot.tagName = 'div'

Quill.register(VideoBlot, true)

// eslint-disable-next-line no-unused-vars
const quill = new Quill('#editor', {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{
        header: '2'
      }, {
        header: '3'
      }, 'blockquote'],
      [{
        list: 'ordered'
      }, {
        list: 'bullet'
      }],
      ['link', 'image', 'video']
    ]
  },
  placeholder: '%%Начните писать статью...%%',
  theme: 'bubble'
})

const tooltip = quill.theme.tooltip
const input = tooltip.root.querySelector('input[data-link]')
input.dataset.link = 'https://horseexperts.ru'

document.querySelector('.post-body .header h1, .post-body .anons').addEventListener('paste', (e) => {
  e.stopPropagation()
  e.preventDefault()
  const sel = window.getSelection()
  const range = sel.getRangeAt(0)
  range.deleteContents()
  const clipboardData = e.clipboardData || window.clipboardData
  const pastedData = clipboardData.getData('Text')
  const textNode = document.createTextNode(pastedData)
  range.insertNode(textNode)
  range.setStartAfter(textNode)
})

let change = false
quill.on('text-change', () => {
  $('.timer').text('%%скоро сохранение%%')
  change = true
})
document.querySelector('.post-body .header h1').addEventListener('input', () => {
  $('.timer').text('%%скоро сохранение%%')
  change = true
})
document.querySelector('.post-body .header .anons').addEventListener('input', () => {
  $('.timer').text('%%скоро сохранение%%')
  change = true
})


setInterval(() => {
  if (change) {
    saveArticle()
  }
}, 10 * 1000)

// eslint-disable-next-line consistent-return
window.onbeforeunload = () => {
  if (change) {
    return 'There are unsaved changes. Are you sure you want to leave?'
  }
}

function saveArticle(glass) {
  const obj = $('.save-btn')
  change = false
  $.ajax({
    dataType: 'json',
    type: 'post',
    url: '/api/save.json',
    data: `id=${$(obj).attr('data-id')}&title=${encodeURIComponent($('.post-body .header h1').text())}&anons=${encodeURIComponent($('.post-body .anons').text())}&body=${encodeURIComponent(quill.root.innerHTML)}`,
    beforeSend: () => {
      if (glass) {
        $('.glass').show()
      }
      $('.timer').text('сохранение')
      obj.prepend('<i class="icon-spinner icon-spin"></i>')
    },
    success: (data) => {
      obj.find('.icon-spinner').remove()
      $('.glass').hide()
      if (data.error) {
        //
      } else {
        $('.timer').text(`сохранено ${moment().format('HH:mm:ss')}`)
        if ($(obj).attr('data-id') === '0') {
          $(obj).attr('data-id', data.id)
        }
      }
    },
    error: (jqXHR, textStatus, errorThrown) => {
      window.console.log(jqXHR, textStatus, errorThrown)
    }
  })
}
